/**
 * CustomLocationRow Component
 *
 * Custom DataGrid row component for locations that displays vacation indicators.
 * This component wraps the standard GridRow with a vacation indicator when
 * the location has active vacation holds.
 *
 * Usage in DataGridPro:
 * ```jsx
 * <DataGridPro
 *   rows={locationRows}
 *   slots={{
 *     row: CustomLocationRow,
 *   }}
 * />
 * ```
 *
 * @param {object} props - Standard DataGrid row props
 * @param {object} props.row - Location row data
 * @param {boolean} props.row.isOnVacationHold - Whether the location has active vacation holds
 */
import React from 'react'
import { GridRow } from '@mui/x-data-grid-pro'
import WithVacationIndicator from 'components/locations/WithVacationIndicator'
import PropTypes from 'prop-types'

const CustomLocationRow = props => {
  const { row } = props
  const { isOnVacationHold } = row

  return (
    <WithVacationIndicator showIndicator={isOnVacationHold} {...props}>
      <GridRow {...props} />
    </WithVacationIndicator>
  )
}

CustomLocationRow.propTypes = {
  row: PropTypes.shape({
    isOnVacationHold: PropTypes.bool,
  }),
}

export default CustomLocationRow
